<template>
    <GenreDetail v-if="currentGenre" :genre="currentGenre" />
</template>

<script>
import GenreDetail from '@/components/GenreDetail.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'Genre',
    components: {
        GenreDetail
    },
    data(){
        return {
            genreId: -1
        }
    },
    computed:{
        ...mapGetters({
            genre: 'productCatalog/genre'
        }),
        currentGenre(){
            let gnr = this.genre(this.genreId)
            return gnr
        }
    },
    watch: {
        '$route.params.id': function(){
            this.loadGenreInfo()
        }
    },
    created(){
        window.scrollTo(0,0)
        this.loadGenreInfo()
    },
    methods:{
        ...mapActions({
            loadGenre: 'productCatalog/loadGenre'
        }),
        loadGenreInfo(){
            this.genreId = Number(this.$route.params.id)
            if(!this.currentGenre)
            {
                this.loadGenre(this.genreId).then(response => {
                    if(this.currentGenre === null){
                        this.$router.push({ name: '404' })
                    }
                }).catch((response) => {
                    this.$router.push({ name: '404' })
                })
            }
        }
    }

}
</script>